<div class="arrowHolder" (mouseenter)="onArrowOver($event, -1)" (mouseleave)="onArrowOut($event, -1)">
    <mat-icon class="arrowImg" aria-hidden="false" aria-label="Example home icon" fontIcon="arrow_back_ios"></mat-icon>
</div>